angular.module('invoice')
    .component('invoiceKsefBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/invoice/ksef/_btn-options.html',
        controller: function (InvoiceService, KsefService, Principal) {
            this.InvoiceService = InvoiceService
            this.KsefService = KsefService

            this.$onInit = () => {
                Principal.currentUser().then(user => {
                    this.isWorker = this.item.worker.id === user.id
                })

            }
        }
    })
